import { h, Component } from 'preact';
import Screening from 'components/shared/theaters/screening';
import s from 'components/shared/theaters/screenings.sss';

// Generic class used by screeningsByFormat and screeningsByTitle
export default class ScreeningsByCategory extends Component {

	constructor() {
		super();
		this.state = {};
	}

	componentDidMount() {}

	componentDidUpdate() {}

	renderSetup() {}

	getLookup(screenings) {
		return [{ name: 'all', screenings }];
	}

	getCategoryName(category, catIndex) {
		return '';
	}

	render(props) {
		const {
			appData,
			selectedDate,
			stDate,
			prevSelectedDate,
			screenings,
		} = props;

		const copy = appData.copy;
		let ref;
		if (stDate === selectedDate) {
			this.$activeScreenings = null;
			this.$firstScreening = null;
			ref = (e => this.$activeScreenings = e);
		}
		const screeningRef = (catIndex, screeningIndex) => {
			if (catIndex === 0 && screeningIndex === 0)
				return (e => e && (this.$firstScreening = e));
			return undefined;
		};

		const className = [s.dateTimes,
			stDate === selectedDate && s.currentDate,
			prevSelectedDate && selectedDate.date < prevSelectedDate.date && s.right
		].filter(e => e).join(' ');

		this.renderSetup();

		const categories = this.getLookup(screenings);

		return (
			<div class={className} key={stDate && stDate.id} ref={ref}>
				{[].concat(...categories.map((cat, catIndex) => {
					if (!cat.screenings) {
						return;
					}
					// ↑ concat to flatten the array (e.g. [[1,2],[3,4],5] -> [1,2,3,4,5])
					const res = cat.screenings.map((sc, i) => (
						<Screening
							{...this.props}
							ref={screeningRef(catIndex, i)}
							copy={copy}
							screening={sc}
							date={stDate && stDate.date}
						/>
					));

					const elems = [];
					const nameEl = this.getCategoryName(cat, catIndex);
					if (nameEl) elems.push(nameEl);
					return elems.concat(<div class={s.screeningsList}>{res}</div>);
				}))}
			</div>
		);
	}

}
